module.exports = __webpack_public_path__ + "static/img/success.f804d88.gif";


//////////////////
// WEBPACK FOOTER
// ./src/admin/assets/img/fingerprint/success.gif
// module id = wGYC
// module chunks = 15